import type { EntryPoint, EntryPointComponent } from 'react-relay';
/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import OnboardingHubPageComponentQuery from './__generated__/OnboardingHubPageComponentQuery.graphql';
import type { OnboardingHubQueries } from './OnboardingHubQueries.types.tsx';

type OnboardingHubEntryPointComponent = EntryPointComponent<OnboardingHubQueries, {}, {}, {}>;

export const onboardingHubEntryPoint: EntryPoint<
	OnboardingHubEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<OnboardingHubEntryPointComponent>(
		/* webpackChunkName: "async-onboarding-hub" */ './OnboardingHubPageComponent.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ tenantContext }: EntryPointRouteParams) => {
		const { appEditions, cloudId, isAdmin } = tenantContext;
		const queries = {
			onboardingHubQuery: {
				options: { fetchPolicy: 'store-and-network' as const },
				parameters: OnboardingHubPageComponentQuery,
				variables: {
					cloudId,
					upsellEnabled: appEditions?.software !== 'PREMIUM_EDITION',
					hamsProductKey: 'jira-software.ondemand',
					rollingIntervals: [
						'DAYS_1' as const,
						'DAYS_7' as const,
						'DAYS_30' as const,
						'DAYS_90' as const,
						'DAYS_180' as const,
					],
					// We can skip the permission check when:
					// 1. The user is an admin (because admins can automatically manage custom onboarding configs), or
					// 2. Upsell is enabled (because upsell is only available to admins)
					skipDelegatedAdminCheck: isAdmin || appEditions?.software !== 'PREMIUM_EDITION',
				},
			},
		};
		return { queries };
	},
});
